import getSymbolFromCurrency from 'currency-symbol-map'

export const localesDef = 'en-US'
export const currencyDef = 'USD'

export default function formatPrice(
  price,
  locales = localesDef,
  currency = currencyDef
) {
  const currCountry = currency ? currency : currencyDef
  const curr = price && (price + '').replace(/(\.|,)00$/g, '')
  const symbol = getSymbolFromCurrency(currCountry)

  return `${symbol || '$'}${curr}${
    currency && currency !== currencyDef ? ` ${currency}` : ''
  }`
}
